import React from 'react';
import { PopupButton } from '@components/basics/PopupButton';

export const NewNotificationButton = ({
  bottom = 10,
  isVisible,
  onClick,
  loading,
}: {
  bottom?: number;
  isVisible: boolean;
  onClick?: () => void;
  loading?: boolean;
}) => {
  return (
    <PopupButton
      isVisible={isVisible}
      label="new notification"
      bottom={bottom}
      onClick={onClick}
      loading={loading}
    />
  );
};
